import React from 'react';
import ContentItemCharactersBlock from 'js/components/content-item/ContentItem.characters-block';

const ContentItemCharactersGrid = ({ data, display_desc }) => {
  const renderContentItems = () => {
    return data.map((item) => {
      if (!item) return null;
      return (
        <li key={item.id} className="content-item__item">
          <ContentItemCharactersBlock item={item} key={item.id} display_desc={display_desc} />
        </li>
      );
    });
  };

  return <ul className="content-item__grid content-item__grid--characters">{renderContentItems()}</ul>;
};

export default ContentItemCharactersGrid;
